<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="商品名称">
        <el-input v-model="query.name" placeholder="输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.type">
          <el-option
            v-for="(item, i) in typeList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status">
          <el-option
            v-for="(item, i) in statusList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #name="{ row }">
        <div>{{ row.name }}<i @click="copyText(row)" class="el-icon-share share"></i></div>
      </template>
      <template #type="{ row }">
        <div>{{ $getLabel(typeList, row.type) }}</div>
      </template>
      <template #ilk="{ row }">
        <div>{{ $getLabel(ilkList, row.ilk) }}</div>
      </template>
       <template #settle="{ row }">
        <div>积分抵扣{{ row.point_deduction_ratio }}%</div>
        <div>结算{{ row.settlement_ratio }}%</div>
      </template>
      <template #status="{ row }">
        <el-tag type="info" v-if="row.status === 0">待审核</el-tag>
        <el-tag type="success" v-if="row.status === 1">上架中</el-tag>
        <el-tag type="warning" v-if="row.status === 2">已下架</el-tag>
         <el-tag type="warning" v-if="row.status === 3">审核拒绝</el-tag>
      </template>
      <template #handle="{ row }">
        <div v-if="row.type != 'consume'">
          <el-button size="small" type="primary" @click="update(row)"
            >编辑</el-button
          >
          <el-button
            size="small"
            v-if="row.status != 1"
            type="success"
            @click="updateStatus(row, 1)"
            >上架</el-button
          >
          <el-button
            size="small"
            v-if="row.status === 1"
            type="warning"
            @click="updateStatus(row, 2)"
            >下架</el-button
          >
          <!-- 添加审核按钮 -->
          <el-button
            size="small"
            type="info"
            v-if="row.status === 0"
            @click="openAuditDialog(row)"
          >审核</el-button>

          <el-popover
            placement="bottom"
            title="支付方式"
            width="300"
            trigger="click"
          >
          <div>
            <div>
              购买链接：
            </div>
            <div>
              {{getUrl(row)}}
            </div>
            <div>
              联营社购买链接：
            </div>
             <el-radio-group v-model="way">
              <el-radio label="buy">购买</el-radio>
              <el-radio label="dep">押金</el-radio>
            </el-radio-group>
              <el-button size="small" @click="openSharePop(row)" type="primary"
              >生成联营社码</el-button
            >
          </div>
           
            <el-button size="small" type="primary" slot="reference"
              >二维码</el-button
            >
          </el-popover>
        </div>
      </template>
    </auto-table>

   <shareCode ref="code"></shareCode>
   
   <!-- 审核对话框 -->
   <el-dialog
     title="商品审核"
     :visible.sync="auditDialogVisible"
     width="500px"
     :close-on-click-modal="false"
   >
     <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="120px">
       <el-form-item label="审核结果" prop="status">
         <el-select v-model="auditForm.status" placeholder="请选择审核结果">
           <el-option label="通过" value="1"></el-option>
           <el-option label="拒绝" value="3"></el-option>
         </el-select>
       </el-form-item>
       <el-form-item 
         label="积分抵扣比例" 
         prop="point_deduction_ratio"
         v-if="auditForm.status === '1'"
       >
         <el-input-number
           v-model="auditForm.point_deduction_ratio"
           :min="0"
           :max="100"
           placeholder="请输入积分抵扣比例（0-100）"
         ></el-input-number>
         <span style="margin-left: 10px;">%</span>
       </el-form-item>
       <el-form-item 
         label="结算比例" 
         prop="settlement_ratio"
         v-if="auditForm.status === '1'"
       >
         <el-input-number
           v-model="auditForm.settlement_ratio"
           :min="0"
           :max="100"
           placeholder="请输入结算比例（0-100）"
         ></el-input-number>
         <span style="margin-left: 10px;">%</span>
       </el-form-item>
       <el-form-item 
         label="拒绝原因" 
         prop="reject_reason"
         v-if="auditForm.status === '2'"
       >
         <el-input
           type="textarea"
           v-model="auditForm.reject_reason"
           placeholder="请输入拒绝原因"
           :rows="3"
         ></el-input>
       </el-form-item>
     </el-form>
     <div slot="footer" class="dialog-footer">
       <el-button @click="auditDialogVisible = false">取消</el-button>
       <el-button type="primary" @click="submitAudit" :loading="auditLoading">确定</el-button>
     </div>
   </el-dialog>
  </div>
</template>

<script>
import shareCode from "../outSchool/components/mechanism/shareCode.vue";
import { typeList, statusList, ilkList } from "./components/type.js";
export default {
  components: {
    shareCode,
  },
  data() {
    return {
      nav: { firstNav: "商品管理", secondNav: "商品列表" },
      DataList: [],
      query: {
        name: "",
        type: "",
      
      },
      typeList: typeList,
      ilkList: ilkList,
      statusList: statusList,
      Option: [
        { name: "名称", value: "name", type: "custom" },
        { name: "售价", value: "min_price" },
        { name: "类型", value: "type", type: "custom" },
        { name: "已售", value: "sale_num" },
        { name: "状态", value: "status", type: "custom" },
        { name: "上架模块", value: "ilk", type: "custom" },
        { name: "结算", value: "settle", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      Total: 0,
      way: "buy",
      // 审核相关数据
      auditDialogVisible: false,
      currentProduct: {},
      auditForm: {
        status: '',
        point_deduction_ratio: 10,
        settlement_ratio: 70,
        reject_reason: ''
      },
      auditRules: {
        status: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        point_deduction_ratio: [
          { required: true, message: '请输入积分抵扣比例', trigger: 'blur' }
        ],
        settlement_ratio: [
          { required: true, message: '请输入结算比例', trigger: 'blur' }
        ],
        reject_reason: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      },
      auditLoading: false
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    getUrl(row){
      return 'https://joingroup.huihejituan.com/#/product/'+row.id;
    },
     async copyText(row){
      let url = 'https://joingroup.huihejituan.com/#/product/'+row.id;
        await navigator.clipboard.writeText(url);  
        this.$message('复制成功')
    },
    openSharePop(row) {
       let query = `id=${row.id}`
       let title = row.name
      if(this.way == 'dep'){
         query = `id=${row.id}&way=dep`
         title += '-押金'
      }

     
      let p = {
        platform: "mechanism_mp",
        page: 'subpackages/service/product/productDetails',
        scene: query,
        title: title,
      };
      this.$refs.code.openShare(p);
    },
    updateStatus(row, status) {
      this.$axios({
        url: "/user/product/update",
        method: "post",
        data: {
          id: row.id,
          status,
        },
      }).then((res) => {
        this.getList(1);
      });
    },

    add() {
      this.$router.push({ name: "createProduct" });
    },
    update(row) {
      this.$router.push({ name: "createProduct", query: { id: row.id } });
    },

    // 打开审核对话框
    openAuditDialog(row) {
      this.currentProduct = { ...row };
      this.auditForm = {
        status: '',
        point_deduction_ratio: row.point_deduction_ratio || 10,
        settlement_ratio: row.settlement_ratio || 70,
        reject_reason: ''
      };
      this.auditDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.auditForm) {
          this.$refs.auditForm.clearValidate();
        }
      });
    },

    // 提交审核
    submitAudit() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          this.auditLoading = true;
          const params = {
            id: this.currentProduct.id,
            status: this.auditForm.status
          };
          
          // 如果审核通过，添加比例参数
          if (this.auditForm.status === '1') {
            params.point_deduction_ratio = this.auditForm.point_deduction_ratio;
            params.settlement_ratio = this.auditForm.settlement_ratio;
          }
          
          // 如果审核拒绝，添加拒绝原因
          if (this.auditForm.status === '2') {
            params.reject_reason = this.auditForm.reject_reason;
          }

          this.$axios({
            url: "/user/product/update",
            method: "post",
            data: params,
          }).then((res) => {
            this.auditLoading = false;
            this.$message.success('审核成功');
            this.auditDialogVisible = false;
            this.getList(1);
          }).catch((error) => {
            this.auditLoading = false;
            this.$message.error('审核失败，请重试');
          });
        }
      });
    },

    //记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/product/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          name: this.query.name || null,
          status: this.query.status,
          ilk: 'dsh_shop'
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.share{
  color: rgb(62, 136, 206);
}
</style>